import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { FindingSeverity } from '../../types/validation.types';
import { Error as ErrorIcon, Warning, CheckCircle } from '@mui/icons-material';

interface FindingSeverityBadgeProps {
  severity: FindingSeverity;
  size?: 'small' | 'medium';
  showIcon?: boolean;
}

const SEVERITY_CONFIG: Record<FindingSeverity, { color: ChipProps['color']; label: string; icon: React.ReactNode }> = {
  FAIL: { color: 'error', label: 'Fail', icon: <ErrorIcon fontSize="small" /> },
  WARN: { color: 'warning', label: 'Warning', icon: <Warning fontSize="small" /> },
  PASS: { color: 'success', label: 'Pass', icon: <CheckCircle fontSize="small" /> },
};

const FindingSeverityBadge: React.FC<FindingSeverityBadgeProps> = ({ 
  severity, 
  size = 'small',
  showIcon = true 
}) => {
  const config = SEVERITY_CONFIG[severity];

  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      {...(showIcon && { icon: config.icon as any })}
      sx={{ fontWeight: 600 }}
    />
  );
};

export default FindingSeverityBadge;
